import editableSelect from "./editableSelect.component";

const editableSelectModule = angular
  .module("app.components.editableSelect", [])
  .component("editableSelect", editableSelect);

export default editableSelectModule;



// WEBPACK FOOTER //
// ./src/components/editableSelect/editableSelect.module.js